import { Dispatch, FC, SetStateAction } from 'react';
import { Text } from '@livechat/design-system-react-components';

import Config from 'Config';
import { SigninFormData } from 'types/form';
import { CustomLink } from 'components/link/Link';
import { LoginWithButton } from 'components/button/LoginWithButton';
import { pushExternalRedirectToDataLayer } from 'helpers/tracking';
import { detectProduct, getAppLinkByName, getProductName } from 'helpers/product';

import { SigninMethod } from './SigninForm';
import Tracking from './signin-tracking';

import * as styles from './styles';

declare const window: any;

type Props = {
  formData: SigninFormData;
  setSigninMethod: Dispatch<SetStateAction<SigninMethod>>;
};

export const SignInLoginMethods: FC<Props> = ({ formData, setSigninMethod }) => {
  const { email } = formData;

  const handleLoginWithExternalProvider = (signinMethod: SigninMethod, e: Event) => {
    e.preventDefault();
    setSigninMethod(signinMethod);

    const product = detectProduct();
    if (product) {
      pushExternalRedirectToDataLayer(getAppLinkByName(getProductName(product)));
    }

    Tracking.handleSignInClick(signinMethod.toLowerCase())();
    window.location = `${Config.accounts_api_url}/oauth/${signinMethod.toLowerCase()}/login${window.location.search}`;
  };

  return (
    <>
      <LoginWithButton
        onClick={(e: Event) => handleLoginWithExternalProvider(SigninMethod.Google, e)}
        caption="Log in with"
        company="Google"
      />
      <LoginWithButton
        onClick={(e: Event) => handleLoginWithExternalProvider(SigninMethod.Microsoft, e)}
        caption="Log in with"
        company="Microsoft"
      />
      <LoginWithButton
        onClick={(e: Event) => handleLoginWithExternalProvider(SigninMethod.Apple, e)}
        caption="Log in with"
        company="Apple"
      />
      <Text size="md" css={styles.customSSO}>
        <CustomLink to={`/custom-sso/${email}`} onClick={Tracking.handleSignInClick('custom sso')}>
          Log in with custom SSO
        </CustomLink>
      </Text>
    </>
  );
};
